import s from "./_common.js";
import { createTheme as d } from "../../_mixins/use-theme.js";
import C from "../../_styles/common/light.js";
import b from "../../_internal/scrollbar/styles/light.js";
import h from "../../button/styles/light.js";
import f from "../../input/styles/light.js";
function u(r) {
  const {
    popoverColor: i,
    textColor2: t,
    primaryColor: e,
    hoverColor: m,
    dividerColor: l,
    opacityDisabled: a,
    boxShadow2: n,
    borderRadius: o,
    iconColor: c,
    iconColorDisabled: p
  } = r;
  return Object.assign(Object.assign({}, s), {
    panelColor: i,
    panelBoxShadow: n,
    panelDividerColor: l,
    itemTextColor: t,
    itemTextColorActive: e,
    itemColorHover: m,
    itemOpacityDisabled: a,
    itemBorderRadius: o,
    borderRadius: o,
    iconColor: c,
    iconColorDisabled: p
  });
}
const g = d({
  name: "TimePicker",
  common: C,
  peers: {
    Scrollbar: b,
    Button: h,
    Input: f
  },
  self: u
}), y = g;
export {
  y as default,
  u as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/styles/light.js
// module id = 937
// module chunks = 41